import { PaymentFailedComponent } from './main/list-abonnements/components/payment-failed/payment-failed.component';
import { PaymentSuccessComponent } from './main/list-abonnements/components/payment-success/payment-success.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { mainGuard } from './core/guards/main.guard';
import { authenticationGuard } from './core/guards/auth.guard';
import { NotFoundComponent } from './main/not-found/not-found.component';
import { NoInternetComponent } from './widgets/no-internet/no-internet.component';
import { ChangeOfferSuccessComponent } from '@main/list-abonnements/components/change-offer-success/change-offer-success.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [authenticationGuard.canActivate],
  },
  {
    path: 'success',
    component: PaymentSuccessComponent,
  },
  {
    path: 'subscription-success',
    component: ChangeOfferSuccessComponent,
  },
  {
    path: 'refuse',
    component: PaymentFailedComponent,
  },
  {
    path: 'failed',
    component: PaymentFailedComponent,
  },
  {
    path: 'no-internet',
    component: NoInternetComponent,
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./main/main.module').then((m) => m.MainModule),
        canActivate: [mainGuard.canActivate],
      },
    ],
  },
  ///
  { path: '**', redirectTo: '404' },
  {
    path: '404',
    component: NotFoundComponent,
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
